/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MCPAllowedTools,
  MCPAllowedTools$inboundSchema,
  MCPAllowedTools$Outbound,
  MCPAllowedTools$outboundSchema,
} from "./mcpallowedtools.js";
import {
  MCPRequireApproval,
  MCPRequireApproval$inboundSchema,
  MCPRequireApproval$outboundSchema,
} from "./mcprequireapproval.js";

export type CreateMcpServerRequest = {
  name: string;
  serverLabel: string;
  serverUrl: string;
  serverDescription?: string | null | undefined;
  allowedTools?: MCPAllowedTools | null | undefined;
  requireApproval?: MCPRequireApproval | undefined;
  metadata?: { [k: string]: any } | undefined;
};

/** @internal */
export const CreateMcpServerRequest$inboundSchema: z.ZodType<
  CreateMcpServerRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  server_label: z.string(),
  server_url: z.string(),
  server_description: z.nullable(z.string()).optional(),
  allowed_tools: z.nullable(MCPAllowedTools$inboundSchema).optional(),
  require_approval: MCPRequireApproval$inboundSchema.optional(),
  metadata: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    "server_label": "serverLabel",
    "server_url": "serverUrl",
    "server_description": "serverDescription",
    "allowed_tools": "allowedTools",
    "require_approval": "requireApproval",
  });
});
/** @internal */
export type CreateMcpServerRequest$Outbound = {
  name: string;
  server_label: string;
  server_url: string;
  server_description?: string | null | undefined;
  allowed_tools?: MCPAllowedTools$Outbound | null | undefined;
  require_approval?: string | undefined;
  metadata?: { [k: string]: any } | undefined;
};

/** @internal */
export const CreateMcpServerRequest$outboundSchema: z.ZodType<
  CreateMcpServerRequest$Outbound,
  z.ZodTypeDef,
  CreateMcpServerRequest
> = z.object({
  name: z.string(),
  serverLabel: z.string(),
  serverUrl: z.string(),
  serverDescription: z.nullable(z.string()).optional(),
  allowedTools: z.nullable(MCPAllowedTools$outboundSchema).optional(),
  requireApproval: MCPRequireApproval$outboundSchema.optional(),
  metadata: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    serverLabel: "server_label",
    serverUrl: "server_url",
    serverDescription: "server_description",
    allowedTools: "allowed_tools",
    requireApproval: "require_approval",
  });
});

export function createMcpServerRequestToJSON(
  createMcpServerRequest: CreateMcpServerRequest,
): string {
  return JSON.stringify(
    CreateMcpServerRequest$outboundSchema.parse(createMcpServerRequest),
  );
}
export function createMcpServerRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateMcpServerRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateMcpServerRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateMcpServerRequest' from JSON`,
  );
}
